import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface TournamentUserTabProps {
  data: Record<string, any>;
}

export const TournamentUserTab: React.FC<TournamentUserTabProps> = ({ data }) => {
  const user = data.user || {};

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  return (
    <div>
      <S.SectionTitle>Основная информация</S.SectionTitle>
      <S.InfoRow>
        <S.InfoLabel>ID</S.InfoLabel>
        <S.InfoValue>{user.id || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Имя пользователя</S.InfoLabel>
        <S.InfoValue>{user.username || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Email</S.InfoLabel>
        <S.InfoValue>{user.email || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Активен</S.InfoLabel>
        <S.InfoValue>
          {user.is_active !== undefined ? (
            <S.Badge $variant={user.is_active ? 'success' : 'error'}>
              {user.is_active ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Сотрудник</S.InfoLabel>
        <S.InfoValue>
          {user.is_staff !== undefined ? (
            <S.Badge $variant={user.is_staff ? 'info' : undefined}>
              {user.is_staff ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Суперпользователь</S.InfoLabel>
        <S.InfoValue>
          {user.is_superuser !== undefined ? (
            <S.Badge $variant={user.is_superuser ? 'warning' : undefined}>
              {user.is_superuser ? 'Да' : 'Нет'}
            </S.Badge>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Дата регистрации</S.InfoLabel>
        <S.InfoValue>{formatDate(user.date_joined)}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Последний вход</S.InfoLabel>
        <S.InfoValue>{formatDate(user.last_login)}</S.InfoValue>
      </S.InfoRow>
    </div>
  );
};

